module.exports = __webpack_public_path__ + "static/media/22ESCWA6.fb6058a3.jpg";